import actionTypes from '../constants/action-types';

const clipboardData = (state = null, action) => {
  if (action.type !== actionTypes.SET_CLIPBOARD_DATA) return state;
  return action.payload.data;
};

export default clipboardData;
